import type {
  CampaignTemplateCustomStyle,
  ClubCampaignPrefectureGroup,
} from "@components/CampaignTemplate";
import CampaignTemplate from "@components/CampaignTemplate";
import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { isTypeProps, queryForSSP } from "@libs/apolloClient";
import { paths } from "@libs/paths";
import { Frontale202203_RawShopsDocument as RawShopsDocument } from "./__generated__/queries";
import styles from "./index.module.css";
import type { Frontale202203_RawShopsQueryResult as RawShopsQueryResult } from "./__generated__/queries";
import type { ApolloError } from "@apollo/client";
import type { GetServerSideProps, NextPage } from "next";

const isProduction = process.env.DEPLOY_ENV === "production";
const PREFECTURES: Array<ClubCampaignPrefectureGroup> = [
  {
    prefecture: "神奈川",
    shopUuids: isProduction
      ? ["wq1ugZLTN6Fz", "xFZPZogr07wA", "8d2bQXJuaP0u"]
      : ["UuidUuidUuid", "UuidUuidUuid", "UuidUuidUuid"],
  },
  {
    prefecture: "東京",
    shopUuids: isProduction ? ["ZqjrvnpySSDj"] : ["UuidUuidUuid"],
  },
];

type Frontale202203PageProps = {
  data?: RawShopsQueryResult["data"];
  prefectures?: Array<ClubCampaignPrefectureGroup>;
  error?: ApolloError;
};

const Frontale202203: NextPage<Frontale202203PageProps> = ({
  data,
  prefectures,
}) => {
  return (
    <CommonLayout hasFooter noModal>
      <CommonHead
        title={
          "川崎フロンターレをお店で応援！川崎フロンターレを観戦できるスポーツバー"
        }
        description={
          "明治安田J1リーグ、AFCチャンピオンズリーグの川崎フロンターレ戦を応援できる川崎、武蔵小杉などのDAZN公式契約スポーツバーをご紹介。応援フードも販売中。スポーツバー探し、予約はFanstaで。"
        }
        ogUrl={paths.campaignFrontale202203}
        ogImage={`${process.env.APP_HOST}/img/campaign/frontale-202203/ogp.png`}
        canonicalUrl={paths.campaignFrontale202203}
      />
      <CampaignTemplate
        teamName="川崎フロンターレ"
        slug="frontale-202203"
        teamIds={[7]}
        colorText="青黒"
        prefectures={prefectures}
        shopData={data?.rawShops}
        customStyle={styles as CampaignTemplateCustomStyle}
        sportGenreSlug={"soccer"}
        teamSlug={"frontale"}
        specialEventAreaHidden
      />
    </CommonLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  // PREFECTURESに定義されたデータからUUIDを抽出する。
  const shopUuids = PREFECTURES.map((p) => p.shopUuids);
  const flattenShopUuids = ([] as Array<string>).concat(...shopUuids);

  // 該当する店舗を検索する。
  const pageProps = await queryForSSP({
    query: RawShopsDocument,
    variables: {
      uuids: flattenShopUuids,
    },
  });

  if (!isTypeProps(pageProps)) {
    return {
      props: {},
    };
  }

  return {
    props: {
      ...pageProps.props,
      prefectures: PREFECTURES,
    },
  };
};

export default Frontale202203;
